import isEmpty from 'lodash.isempty';
import React from 'react';

import {
    closeModal,
    dateFormatter,
    engagementType,
    getIsRasHH,
    log,
    scrollTo,
    setLastRequestTime,
    showModal,
} from '../../../Utils';
import axiosInstance, { axiosDocumentInstance } from '../../../actions/AxiosInstance';
import api from '../../../actions/EndPoints';
import connectWithUserStore from '../../../reducers/connectWithUserStore';
import { dispatchOverlayLoad } from '../../shared/Analytics';
import EDeliveryContent from './EDeliveryContent';
import { GENERAL_HUB_ERROR_MODAL, HUB_GENERAL_ERROR_OVERLAY, APPLICATION_PDF } from '../../../Constants';

const EDeliveryModalContainer = ({
    state,
    dispatch,
    handleClose,
    setServiceError,
}) => {
    const { apiKey, isCustomerWebView, loadProspectusData } = state;
    const isRasHH = getIsRasHH(state.planningGroup, state.engagementStatus);
    const getEngagementType = engagementType(isRasHH, state.isPrimary);
    const externalGroupId = state?.planningGroup?.externalId;

    const [inProgress, setConsentInProgress] = React.useState(false);
    const [isLoading, setisLoading] = React.useState(false);

    const keyPointsControl = document.querySelectorAll(`[id="checkedKeyPoints-control"]`)[0];
    const eDeliveryControl = document.querySelectorAll(`[id="checkedEdelivery-control"]`)[0];
    const prospectusesControl = document.querySelectorAll(`[id="checkedProspectuses-control"]`)[0];
    const advControl = document.querySelectorAll(`[id="client-agreement-control"]`)[0];
    const keyPointsCheckbox = document.querySelectorAll(`[id="checkedKeyPoints"]`)[0];
    const eDeliveryCheckbox = document.querySelectorAll(`[id="checkedEdelivery"]`)[0];
    const prospectusesCheckbox = document.querySelectorAll(`[id="checkedProspectuses"]`)[0];
    const advCheckbox = document.querySelectorAll(`[id="agreementAdv"]`)[0];

    const [checkError, setCheckError] = React.useState({
        checkedKeyPoints: false,
        checkedEdelivery: false,
        checkedProspectuses: false,
        checkedAdv: false,
    })
    const [checkState, setCheckState] = React.useState({
        checked401k: false,
        checkedYodlee: false,
        checkedTrust: false,
        checkedKeyPoints: false,
        checkedEdelivery: false,
        checkedProspectuses: false,
        checkedAdv: false,
    });

    const handleEDeliveryUpdate = () => {
        dispatch({
            type: 'E_DELIVERY_UPDATED',
            isEdeliveryConsented: true,
        });
    };

    const handleChange = name => event => {
        setCheckState({ ...checkState, [name]: event.target.checked });
    };

    const handleCheckboxErrors = () => {
        const getScrollId = () => {
            if (!checkState.checkedKeyPoints) {
                return 'key-points-container-header'
            }
            if (!checkState.checkedEdelivery) {
                return 'edelivery-container-header'
            }
            if (!checkState.checkedProspectuses) {
                return 'prospectuses-container-header'
            }
            if (!checkState.checkedAdv) {
                return 'client-agreement-container-header'
            }
            return '';
        }
        setCheckError({
            ...checkError,
            checkedProspectuses: !checkState.checkedProspectuses,
            checkedAdv: !checkState.checkedAdv,
            checkedEdelivery: !checkState.checkedEdelivery,
            checkedKeyPoints: !checkState.checkedKeyPoints
        })
        if (!checkState.checkedAdv) {
            advCheckbox.checkValidity();
        }
        if (!checkState.checkedProspectuses) {
            prospectusesCheckbox.checkValidity();
        }
        if (!checkState.checkedEdelivery) {
            eDeliveryCheckbox.checkValidity();
        }
        if (!checkState.checkedKeyPoints) {
            keyPointsCheckbox.checkValidity();
        }

        scrollTo(getScrollId())
    }

    React.useEffect(() => {
        if (checkState?.checkedKeyPoints) {
            Promise.resolve(keyPointsControl.removeAttribute('invalid'))
                .then(() => keyPointsCheckbox.removeAttribute('aria-invalid'))
                .then(() =>
                    setCheckError((prevState) => ({ ...prevState, checkedKeyPoints: false }))
                );
        }
        if (checkState?.checkedEdelivery) {
            Promise.resolve(eDeliveryControl.removeAttribute('invalid'))
                .then(() => eDeliveryCheckbox.removeAttribute('aria-invalid'))
                .then(() =>
                    setCheckError((prevState) => ({ ...prevState, checkedEdelivery: false }))
                );
        }
        if (checkState?.checkedProspectuses) {
            Promise.resolve(prospectusesControl.removeAttribute('invalid'))
                .then(() => prospectusesCheckbox.removeAttribute('aria-invalid'))
                .then(() =>
                    setCheckError((prevState) => ({ ...prevState, checkedProspectuses: false }))
                );
        }
        if (checkState?.checkedAdv) {
            Promise.resolve(advControl.removeAttribute('invalid'))
                .then(() => advCheckbox.removeAttribute('aria-invalid'))
                .then(() => setCheckError((prevState) => ({ ...prevState, checkedAdv: false })));
        }
    }, [checkState])


    const eDeliveryAction = state.activeActions && state.activeActions.filter(action => action.actionType === 'E_DELIVERY');

    const headerPayload = {
        engagementType: state.isPrimary ? getEngagementType : null,
        consentEDelivery: true,
        financialPlanningActionId:
            state.activeActions && !isEmpty(eDeliveryAction)
                ? eDeliveryAction[0].financialPlanningActionId
                : null,
    };

    async function retrieveRICMPlan(docType) {
        log(console.log('Calling retrieve RICM plan: ' + docType));
        setisLoading(true);
        setServiceError(false);
        try {
            const getPlan = await axiosDocumentInstance.get(
                `${api.getLatestPlanAPI(externalGroupId)}?docType=${docType}`,
                {
                    responseType: 'arraybuffer',
                    headers: {
                        apikey: `${apiKey}`,
                        Accept: APPLICATION_PDF,
                    },
                }
            );

            if (getPlan) {
                const { data, headers } = getPlan;
                setisLoading(false);
                setLastRequestTime();
                const lastModifiedTimeStamp = headers['last-modified'];
                if (data !== undefined) {
                    const planBlob = new Blob([data], { type: APPLICATION_PDF });
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        // IE and Edge browser use msSaveOrOpenBlob
                        window.navigator.msSaveOrOpenBlob(
                            planBlob,
                            `Personalized_Plan__${docType}__${dateFormatter(
                                lastModifiedTimeStamp,
                                'MM-DD-YYYY'
                            )}.pdf`
                        );
                    } else {
                        try {
                            const link = document.createElement('a');
                            link.href = window.URL.createObjectURL(planBlob);
                            link.download = `Personalized_Plan__${docType}__${dateFormatter(
                                lastModifiedTimeStamp,
                                'MM-DD-YYYY'
                            )}.pdf`;
                            link.click();
                            setTimeout(() => {
                                window.URL.revokeObjectURL(data);
                            }, 100);
                        } catch (e) {
                            log(console.log(e));
                            setisLoading(false);
                            setServiceError(true);
                        }
                    }
                }
            }
        } catch (err) {
            console.log(err);
            setisLoading(false);
            setServiceError(true);
            setLastRequestTime();
        }
    }

    async function retrievePlan() {
        log(console.log('Calling retrieve plan'));
        setConsentInProgress(false);
        setisLoading(true);
        setServiceError(false);
        try {
            const getPlan = await axiosDocumentInstance.get(
                `${api.getLatestPlanAPI(externalGroupId)}?docType=FINANCIAL_PLAN`,
                {
                    responseType: 'arraybuffer',
                    headers: {
                        apikey: `${apiKey}`,
                        Accept: APPLICATION_PDF,
                    },
                }
            );

            if (getPlan) {
                const { data, headers } = getPlan;
                setLastRequestTime();
                setisLoading(false);
                const lastModifiedTimeStamp = headers['last-modified']
                if (data !== undefined) {
                    const planBlob = new Blob([data], { type: APPLICATION_PDF });
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        // IE and Edge browser use msSaveOrOpenBlob
                        window.navigator.msSaveOrOpenBlob(
                            planBlob,
                            `Personalized_Plan_${dateFormatter(
                                lastModifiedTimeStamp,
                                'MM-DD-YYYY'
                            )}.pdf`
                        );
                    } else {
                        try {
                            const link = document.createElement('a');
                            link.href = window.URL.createObjectURL(planBlob);
                            link.download = `Personalized_Plan_${dateFormatter(
                                lastModifiedTimeStamp,
                                'MM-DD-YYYY'
                            )}.pdf`;
                            link.click();
                            setTimeout(() => {
                                window.URL.revokeObjectURL(data);
                            }, 100);
                        } catch (e) {
                            log(console.log(e));
                            setisLoading(false);
                            setServiceError(true);
                        }
                    }
                }
            }
        } catch (err) {
            console.log(err);
            setServiceError(true);
            setisLoading(false);
            setLastRequestTime();
        }
    }

    async function updateConsent() {
        setConsentInProgress(true);
        await axiosInstance
            .put(api.consentAPI, headerPayload, {
                headers: {
                    apikey: `${apiKey}`,
                },
            })
            .then((res) => {
                if (res) {
                    setLastRequestTime();
                    dispatch({
                        type: 'CONSENT_UPDATED',
                        isConsented: true,
                    });
                }
            })
            .then(() => {
                if (isEmpty(eDeliveryAction)) {
                    if (state.ricmPlanClicked) {
                        if (state.releasedStrategyComparison) {
                            retrieveRICMPlan('STRATEGY_COMPARISON');
                        }
                        if (state.releasedSelectedStrategy) {
                            retrieveRICMPlan('SELECTED_STRATEGY');
                        }
                    } else {
                        retrievePlan();
                    }
                } else {
                    log(console.log('Plan not retrieved from E delivery action'));
                }
            })
            .catch((error) => {
                const showErrorModalPromise = Promise.resolve(showModal(GENERAL_HUB_ERROR_MODAL));
                showErrorModalPromise
                    .then(() => console.log(error))
                    .then(() => closeModal('e-delivery'))
                    .then(() => dispatchOverlayLoad(HUB_GENERAL_ERROR_OVERLAY))
                    .then(() => setConsentInProgress(false))
                    .then(() => setLastRequestTime());
            });
    }

    const formCompletion = () => {
        if (checkState.checkedAdv && checkState.checkedKeyPoints && checkState.checkedEdelivery &&
            checkState.checkedProspectuses) {
            updateConsent()
                .then(() => handleEDeliveryUpdate())
                .then(() => handleClose())
                .catch((err) => log(console.log(err)))
        } else {
            handleCheckboxErrors();
        }
    }

    const props = {
        formCompletion,
        setCheckState,
        handleChange,
        checkState,
        checkError,
        inProgress,
        isLoading,
        prospectusesDisplay: loadProspectusData,
        isCustomerWebView,
    }

    return <EDeliveryContent {...props} />;
};

export default connectWithUserStore(EDeliveryModalContainer);
